import { SchemaOf, object } from 'yup';
import { selectSchema } from './BaseSchemas';
import { ModifyRoleAssignment } from 'Models/RoleModels';

export const ModifyRoleAssignmentSchema: SchemaOf<ModifyRoleAssignment> = object({
	proposalId: selectSchema('Proposal', 1),
	personId: selectSchema('Person', 1),
	roleId: selectSchema('Role', 1),
});
